import(/* webpackMode: "eager" */ "/app/src/app/all-units/[unit]/page.tsx");
